import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "assets/theme";
import { Auth, Amplify } from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import routes from "routes";

import { useSoftUIController, setMiniSidenav } from "context";
import { AuthProvider, useAuth } from "context/AuthContext";
import Sidenav from "examples/Sidenav";

import brand from "assets/images/ACT-logo-horiz.png";
import { Header } from "login/header";

import AuthDebug from "layouts/auth-debug";

const awsconfig = {
  Auth: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USER_POOLS_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOLS_WEB_CLIENT_ID,
  },
  API: {
    endpoints: [
      // {
      //   name: 'admin-api',
      //   endpoint: process.env.REACT_APP_ADMIN_API,
      //   custom_header: async () => {
      //     return {
      //       Authorization: `Bearer ${(await Auth.currentSession())
      //         .getIdToken()
      //         .getJwtToken()}`,
      //     };
      //   },
      // },
      {
        name: 'admin-api-v2',
        endpoint: process.env.REACT_APP_ADMIN_API_V2,
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          };
        },
      },
    ],
  },
};
Amplify.configure(awsconfig);

const getRoutes = (allRoutes) =>
  allRoutes.map((route) => {
    if (route.collapse) {
      return getRoutes(route.collapse);
    }

    if (route.route) {
      return <Route exact path={route.route} element={route.component} key={route.key} />;
    }

    return null;
  });

function App({ signOut, user }) {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  return (
    <AuthProvider amplifyUser={user}>
      <AppContent
        signOut={signOut}
        user={user}
        controller={controller}
        dispatch={dispatch}
        onMouseEnter={handleOnMouseEnter}
        onMouseLeave={handleOnMouseLeave}
      />
    </AuthProvider>
  );
}

function AppContent({ signOut, user, controller, dispatch, onMouseEnter, onMouseLeave }) {
  const { loading } = useAuth();
  const { layout, sidenavColor } = controller;

  if (loading) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <CircularProgress />
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <Sidenav
          user={user}
          signOut={signOut}
          color={sidenavColor}
          brand={brand}
          routes={routes}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      )}
      <Routes>
        {getRoutes(routes)}
        <Route path="/auth/info" element={<AuthDebug />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </ThemeProvider>
  );
}

export default withAuthenticator(App, {
  components: {
    SignIn: {
      Header: Header
    }
  },
  hideSignUp: true
});
